/* Native outfit page — cart is 100% Shopify native (/cart/add.js).
 * Render (app proxy) is only used for: analytics, size chart, back-in-stock.
 * Related-outfits widget is native Liquid. Page works if Render is down. */
(function () {
  "use strict";

  var wrap = document.querySelector(".op-wrap");
  var API = (wrap && wrap.getAttribute("data-op-api")) || "";
  var ITEM = (wrap && wrap.getAttribute("data-op-item")) || "";
  var SIZECHART_BASE = (wrap && wrap.getAttribute("data-op-sizechart-base")) ||
    "https://shopify-sync-app-h36w.onrender.com";
  var _viewStart = Date.now();

  function _lbl(key) {
    return (wrap && wrap.getAttribute("data-op-lbl-" + key)) || "";
  }

  /* ── Analytics ──────────────────────────────────────────────────────────── */
  function track(eventType, data) {
    if (!API) return;
    try {
      var payload = Object.assign({ event_type: eventType, item_id: ITEM }, data || {});
      fetch(API + "/events", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  function ga(name, data) {
    try {
      var params = Object.assign({ source: "outfit_page", item_id: ITEM }, data || {});
      if (typeof window.gtag === "function") window.gtag("event", name, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}
  }

  /* ── Money formatting ────────────────────────────────────────────────────── */
  function _formatMoney(cents) {
    if (!cents && cents !== 0) return "—";
    var lang = (wrap && wrap.getAttribute("data-op-lang")) || "it";
    var val = cents / 100;
    try {
      var locale = lang === "en" ? "en-GB" : lang === "de" ? "de-DE" : lang === "fr" ? "fr-FR" : lang === "es" ? "es-ES" : "it-IT";
      return new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(val);
    } catch (e) {
      return "€ " + val.toFixed(2).replace(".", ",");
    }
  }

  /* ── Variant helpers ─────────────────────────────────────────────────────── */
  function selectedOption(sel) { return sel.options[sel.selectedIndex] || null; }

  function firstAvailableIndex(sel) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value && sel.options[i].getAttribute("data-available") === "true") return i;
    }
    return -1;
  }

  /* ── Look total (sums selected variant prices in cents) ──────────────────── */
  function _lookTotals() {
    var total = 0;       // what the shopper pays (discounted)
    var original = 0;    // sum of original / compare-at prices
    var allSelected = true;
    document.querySelectorAll(".op-card .op-variant").forEach(function (sel) {
      var opt = selectedOption(sel);
      if (!opt || !opt.value) { allSelected = false; return; }
      var price = parseInt(opt.getAttribute("data-price-cents") || "0", 10);
      var cmp = parseInt(opt.getAttribute("data-cmp-cents") || "0", 10);
      total += price;
      original += (cmp > price ? cmp : price);
    });
    return { total: total, original: original, savings: Math.max(0, original - total), allSelected: allSelected };
  }

  function _updateLookTotal() {
    var r = _lookTotals();
    var suffix = r.allSelected ? "" : (r.total > 0 ? "+" : "");
    var nowStr = r.total > 0 ? _formatMoney(r.total) + suffix : "—";

    var totalEl = document.getElementById("op-look-total-val");
    var ctaPriceEl = document.getElementById("op-cta-price");
    if (totalEl) totalEl.textContent = nowStr;
    if (ctaPriceEl) ctaPriceEl.textContent = nowStr;

    // Original (struck) total — only shown when there is a genuine saving.
    var origEl = document.getElementById("op-look-total-orig");
    if (origEl) {
      if (r.savings > 0) { origEl.textContent = _formatMoney(r.original) + suffix; origEl.hidden = false; }
      else { origEl.textContent = ""; origEl.hidden = true; }
    }

    // Cumulative saving row.
    var savingsWrap = document.getElementById("op-look-savings");
    var savingsEl = document.getElementById("op-look-savings-val");
    if (savingsWrap && savingsEl) {
      if (r.savings > 0) { savingsEl.textContent = _formatMoney(r.savings); savingsWrap.hidden = false; }
      else { savingsWrap.hidden = true; }
    }
  }

  function syncCardState(sel) {
    var card = sel.closest(".op-card");
    if (!card) return;
    var opt = selectedOption(sel);
    var hasValue = opt && opt.value;
    var available = hasValue && opt.getAttribute("data-available") === "true";
    var addBtn = card.querySelector("[data-add]");
    var notifyBtn = card.querySelector("[data-notify]");
    var bis = card.querySelector("[data-bis]");
    var price = opt && opt.getAttribute("data-price");
    if (price && hasValue) {
      var priceEl = card.querySelector(".op-price");
      if (priceEl) {
        var cmpCents = parseInt(opt.getAttribute("data-cmp-cents") || "0", 10);
        var priceCents = parseInt(opt.getAttribute("data-price-cents") || "0", 10);
        if (cmpCents > priceCents) {
          priceEl.innerHTML = "<s>" + _formatMoney(cmpCents) + "</s> " + price;
        } else {
          priceEl.textContent = price;
        }
      }
    }
    if (!hasValue) {
      if (addBtn) { addBtn.disabled = true; addBtn.style.display = ""; }
      if (notifyBtn) notifyBtn.style.display = "none";
      if (bis) bis.style.display = "none";
    } else if (available) {
      if (addBtn) { addBtn.disabled = false; addBtn.style.display = ""; }
      if (notifyBtn) notifyBtn.style.display = "none";
      if (bis) bis.style.display = "none";
    } else {
      if (addBtn) addBtn.style.display = "none";
      if (notifyBtn) notifyBtn.style.display = "";
    }
    _updateLookTotal();
  }

  /* ── Cart drawer ─────────────────────────────────────────────────────────── */
  function openCartDrawer() {
    var d = document.getElementById("cart-drawer");
    if (!d) return false;
    try {
      if (typeof d.show === "function") { d.show(); return true; }
      d.setAttribute("open", ""); return true;
    } catch (e) { return false; }
  }

  function refreshAndOpenDrawer(result) {
    try {
      var html = result && result.sections && result.sections["cart-drawer"];
      if (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("cart-drawer");
        var cur = document.getElementById("cart-drawer");
        if (fresh && cur) cur.replaceWith(fresh);
      }
    } catch (e) {}
    openCartDrawer();
  }

  function cartAdd(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items, sections: "cart-drawer", sections_url: window.location.pathname }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { return Promise.reject(d); });
      return r.json();
    });
  }

  function refreshCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          ".cart-count-bubble span, .cart-count, [data-cart-count], #cart-icon-bubble span, cart-count"
        ).forEach(function (n) { n.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
      })
      .catch(function () {});
  }

  /* ── Favourites ──────────────────────────────────────────────────────────── */
  function _customerId() {
    try {
      if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) return String(window.Shopify.customer.id);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    } catch (e) {}
    return "";
  }

  function wishlistAdd(payload) {
    var body = Object.assign({ shop: location.hostname, source: "outfit_page", locale: (document.documentElement.lang || "") }, payload);
    var cid = _customerId();
    if (cid) body.customerId = cid;
    return fetch("/apps/wishlist/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); }).catch(function () { return { success: false }; });
  }

  function _cardWishPayload(card) {
    var sel = card.querySelector(".op-variant");
    var opt = sel && selectedOption(sel);
    return {
      productId: String(card.getAttribute("data-product") || ""),
      productHandle: card.getAttribute("data-handle") || "",
      variantId: opt ? String(opt.value) : "",
      selectedSize: opt ? (opt.textContent || "").trim() : "",
    };
  }

  function _opEmailModal(onSubmit) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:2147483001;display:flex;align-items:center;justify-content:center';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:12px;padding:28px 24px;max-width:340px;width:90%;box-sizing:border-box;font-family:inherit';
    box.innerHTML =
      '<p style="margin:0 0 6px;font-size:17px;font-weight:600">Save to Wishlist</p>' +
      '<p style="margin:0 0 14px;font-size:13px;color:#666">Enter your email to save</p>' +
      '<input type="email" placeholder="email@example.com" style="width:100%;box-sizing:border-box;border:1px solid #ddd;border-radius:8px;padding:10px 12px;font-size:15px;margin-bottom:14px">' +
      '<div style="display:flex;gap:10px;justify-content:flex-end">' +
        '<button style="border:none;background:none;padding:10px 16px;font-size:14px;cursor:pointer;color:#555">Cancel</button>' +
        '<button style="border:none;background:#000;color:#fff;padding:10px 20px;border-radius:8px;font-size:14px;cursor:pointer">Save</button>' +
      '</div>';
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    var input = box.querySelector('input');
    var btns = box.querySelectorAll('button');
    function close() { overlay.remove(); }
    btns[0].addEventListener('click', function () { close(); onSubmit(null); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { close(); onSubmit(null); } });
    btns[1].addEventListener('click', function () {
      var em = input.value.trim();
      if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { input.style.borderColor = '#c0392b'; return; }
      close(); onSubmit(em);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btns[1].click(); });
    setTimeout(function () { input.focus(); }, 50);
  }

  function _markFav(btn) {
    if (!btn) return;
    btn.classList.add("is-fav");
    var ico = btn.querySelector(".op-wish-ico");
    if (ico) { ico.innerHTML = "&#9829;"; btn.classList.add("is-on"); return; }
    btn.innerHTML = "&#9829; " + (btn.textContent || "").replace(/^[♡♥]+\s*/, "").trim();
  }

  function _storedWishlistEmail() {
    try { var e = localStorage.getItem("integratedWishlistEmail"); return (e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) ? e : ""; } catch (ex) { return ""; }
  }
  function _saveWishlistEmail(email) {
    try { localStorage.setItem("integratedWishlistEmail", email); } catch (ex) {}
  }

  function _addOneFav(payload, btn, email) {
    var p = Object.assign({}, payload);
    // Use a cached email if available so we don't ask twice.
    if (!email) email = _storedWishlistEmail();
    if (email) p.email = email;
    // Guest with no known email — show modal immediately instead of probing the API first.
    if (!email && !_customerId()) {
      _opEmailModal(function (em) {
        if (!em) return;
        _saveWishlistEmail(em);
        _addOneFav(payload, btn, em);
      });
      return Promise.resolve(false);
    }
    return wishlistAdd(p).then(function (res) {
      if (res && res.success) { _markFav(btn); return true; }
      if (!p.email) {
        _opEmailModal(function (em) {
          if (!em) return;
          _saveWishlistEmail(em);
          _addOneFav(payload, btn, em);
        });
      } else if (res && res.message) { alert(res.message); }
      return false;
    });
  }

  /* ── Gallery ─────────────────────────────────────────────────────────────── */
  var _galleryIdx = 0;

  function galleryGoto(idx) {
    var slides = document.querySelectorAll("[data-gallery] [data-slide]");
    var inner = document.querySelector("[data-gallery] .op-gallery-inner");
    if (!slides.length) return;
    _galleryIdx = ((idx % slides.length) + slides.length) % slides.length;
    if (inner) inner.style.transform = "translateX(-" + (_galleryIdx * 100) + "%)";
    slides.forEach(function (s, i) {
      s.classList.toggle("is-active", i === _galleryIdx);
      var v = s.querySelector("video");
      if (v) { if (i === _galleryIdx) v.play().catch(function () {}); else v.pause(); }
    });
    document.querySelectorAll(".op-dot").forEach(function (d, i) {
      d.classList.toggle("is-active", i === _galleryIdx);
    });
    // Update counter
    var counter = document.getElementById("op-gallery-counter");
    if (counter && slides.length > 1) counter.textContent = (_galleryIdx + 1) + " / " + slides.length;
    // Update thumbnails
    document.querySelectorAll(".op-thumb").forEach(function (t, i) {
      t.classList.toggle("is-active", i === _galleryIdx);
    });
  }

  function galleryNav(dir) {
    var slides = document.querySelectorAll("[data-gallery] [data-slide]");
    if (slides.length < 2) return;
    galleryGoto(_galleryIdx + dir);
  }

  function toggleFullscreen() {
    var g = document.querySelector("[data-gallery]");
    if (!g) return;
    if (!document.fullscreenElement) {
      g.requestFullscreen && g.requestFullscreen().catch(function () {});
    } else {
      document.exitFullscreen && document.exitFullscreen();
    }
  }

  /* ── Add whole look — size confirmation popup ────────────────────────────── */
  function _buildLookItems() {
    var items = [];
    document.querySelectorAll(".op-card .op-variant").forEach(function (sel) {
      var opt = selectedOption(sel);
      if (opt && opt.value && opt.getAttribute("data-available") === "true") {
        var card = sel.closest(".op-card");
        var title = card ? (card.querySelector(".op-card-title") || {}).textContent || "" : "";
        items.push({ id: opt.value, quantity: 1, title: title.trim(), size: (opt.textContent || "").trim() });
      }
    });
    return items;
  }

  var _confirmCardPairs = []; // {origSel, confirmSel} — wired on each showLookConfirm call

  function showLookConfirm() {
    var modal = document.getElementById("op-look-confirm");
    var list  = document.getElementById("op-confirm-list");
    var goBtn = document.getElementById("op-confirm-go");
    if (!modal || !list || !goBtn) return false;

    list.innerHTML = "";
    _confirmCardPairs = [];

    document.querySelectorAll(".op-card").forEach(function (card) {
      var origSel = card.querySelector(".op-variant");
      if (!origSel) return;
      var titleText = ((card.querySelector(".op-card-title") || {}).textContent || "").trim();

      var confirmSel = document.createElement("select");
      confirmSel.className = "op-confirm-select";
      Array.from(origSel.options).forEach(function (o) {
        var avail = o.getAttribute("data-available") === "true";
        var opt = document.createElement("option");
        opt.value = o.value;
        opt.disabled = !avail;
        opt.selected = o.selected;
        opt.textContent = (o.textContent || "").trim() + (avail ? "" : " ✕");
        if (!avail) opt.style.color = "#bbb";
        confirmSel.appendChild(opt);
      });

      var nameSpan = document.createElement("span");
      nameSpan.className = "op-confirm-product";
      nameSpan.textContent = titleText;

      var li = document.createElement("li");
      li.appendChild(nameSpan);
      li.appendChild(confirmSel);
      list.appendChild(li);
      _confirmCardPairs.push({ origSel: origSel, confirmSel: confirmSel });
    });

    modal.hidden = false;
    return true;
  }

  /* ── Immersive modal (related polaroid tap) ──────────────────────────────── */
  function openImm(el, event) {
    event.preventDefault();
    var img = el.getAttribute("data-imm-img") || "";
    var cap = el.getAttribute("data-imm-cap") || "";
    var url = el.getAttribute("data-imm-url") || (el.href || "");
    var modal = document.getElementById("op-imm");
    var imgEl = document.getElementById("op-imm-img");
    var capEl = document.getElementById("op-imm-cap");
    var linkEl = document.getElementById("op-imm-link");
    if (!modal) { window.location.href = url; return; }
    if (imgEl) { imgEl.src = img; imgEl.alt = cap; }
    if (capEl) capEl.textContent = cap;
    if (linkEl) { linkEl.href = url; linkEl.textContent = _lbl("shop") || "Shop this look →"; }
    modal.hidden = false;
    document.getElementById("op-imm").addEventListener("click", function onOverlay(e) {
      if (e.target === modal) { modal.hidden = true; modal.removeEventListener("click", onOverlay); }
    });
  }

  /* ── Main OutfitPage object ──────────────────────────────────────────────── */
  var OutfitPage = {
    onVariantChange: function (sel, itemId) {
      syncCardState(sel);
      track("product_tag_tap", { item_id: itemId || ITEM });
    },

    addToCart: function (btn, productId, itemId) {
      var card = btn.closest(".op-card");
      var sel = card && card.querySelector(".op-variant");
      var opt = sel && selectedOption(sel);
      if (!opt || !opt.value || opt.getAttribute("data-available") !== "true") return;
      var variantId = opt.value;
      var addedLbl = _lbl("added") || "Aggiunto ✓";
      var addingLbl = "Aggiungo…";
      var origLbl = btn.textContent;
      btn.disabled = true;
      btn.textContent = addingLbl;
      track("add_to_cart", { product_id: productId, variant_id: String(variantId), item_id: itemId || ITEM });
      cartAdd([{ id: variantId, quantity: 1 }])
        .then(function (result) {
          btn.textContent = addedLbl;
          refreshCartCount();
          refreshAndOpenDrawer(result);
          ga("add_to_cart", { item_id: itemId || ITEM, product_id: productId, variant_id: String(variantId) });
          if (window.fbq) fbq('track', 'AddToCart', { content_ids: [itemId || ITEM], content_type: 'product_group', currency: 'EUR' });
          setTimeout(function () { btn.textContent = origLbl; btn.disabled = false; }, 2000);
        })
        .catch(function (err) {
          btn.textContent = origLbl;
          btn.disabled = false;
          alert((err && err.description) || "Could not add to cart");
        });
    },

    addLook: function (btn) {
      var items = _buildLookItems();
      if (!items.length) { alert(_lbl("no-size") || "No available sizes selected."); return; }
      var origLbl = btn.innerHTML;
      var lookAddedLbl = _lbl("look-added") || "Look aggiunto ✓";
      if (!showLookConfirm()) {
        _doAddLook(btn, items, origLbl, lookAddedLbl);
        return;
      }
      var goBtn = document.getElementById("op-confirm-go");
      var newGoBtn = goBtn.cloneNode(true);
      goBtn.parentNode.replaceChild(newGoBtn, goBtn);
      newGoBtn.addEventListener("click", function () {
        document.getElementById("op-look-confirm").hidden = true;
        // Sync any size changes made in the popup back to the card selects
        _confirmCardPairs.forEach(function (pair) {
          if (pair.confirmSel.value && pair.confirmSel.value !== pair.origSel.value) {
            pair.origSel.value = pair.confirmSel.value;
            pair.origSel.dispatchEvent(new Event("change"));
          }
        });
        var newItems = _buildLookItems();
        _doAddLook(btn, newItems.length ? newItems : items, origLbl, lookAddedLbl);
      });
    },

    favProduct: function (btn) {
      var card = btn.closest(".op-card");
      if (!card) return;
      var productId = card.getAttribute("data-product");
      var handle = card.getAttribute("data-handle") || "";
      track("save_product", { product_id: productId });
      ga("save_product", { product_id: productId });
      // Preferred: reuse the shared wishlist modal (size picker + email capture)
      // so the experience is identical to collection/product pages.
      if (handle && window.IntegratedWishlist && window.IntegratedWishlist.open) {
        window.IntegratedWishlist.open({ handle: handle, productId: productId, source: "outfit_page", button: btn });
        return;
      }
      _addOneFav(_cardWishPayload(card), btn); // fallback when the app embed is absent
    },

    favLook: function (btn) {
      var cards = [].slice.call(document.querySelectorAll(".op-card"));
      if (!cards.length) return;
      track("save_look", {});
      ga("save_look", {});
      if (window.IntegratedWishlist && window.IntegratedWishlist.addItems) {
        var payloads = cards.map(function (c) {
          var p = _cardWishPayload(c);
          return { productId: p.productId, productHandle: p.productHandle, variantId: p.variantId, selectedSize: p.selectedSize, source: "outfit_page" };
        });
        window.IntegratedWishlist.addItems(payloads, { title: _lbl("shop") || "Wishlist" }).then(function (res) {
          if (res && res.ok) _markFav(btn);
        });
        return;
      }
      // Fallback when the app embed is absent.
      function run(email) {
        return Promise.all(cards.map(function (c) {
          var p = _cardWishPayload(c);
          if (email) p.email = email;
          return wishlistAdd(p);
        }));
      }
      var knownEmail = _storedWishlistEmail();
      if (!knownEmail && !_customerId()) {
        // Guest with no cached email — ask immediately, no API probe needed.
        _opEmailModal(function (em) {
          if (!em) return;
          _saveWishlistEmail(em);
          run(em).then(function () { _markFav(btn); });
        });
        return;
      }
      run(knownEmail || undefined).then(function (results) {
        var needEmail = results.some(function (r) { return !(r && r.success); });
        if (needEmail && !_customerId()) {
          _opEmailModal(function (em) {
            if (!em) return;
            _saveWishlistEmail(em);
            run(em).then(function () { _markFav(btn); });
          });
          return;
        }
        _markFav(btn);
      });
    },

    toggleBis: function (btn) {
      var card = btn.closest(".op-card");
      if (!card) return;
      var sel = card.querySelector(".op-variant");
      var opt = sel && selectedOption(sel);
      var titleEl = card.querySelector(".op-card-title");
      var imgEl = card.querySelector(".op-card-img");
      var productId = card.getAttribute("data-product") || "";
      ga("back_in_stock_open", { product_id: productId, variant_id: opt ? String(opt.value) : "" });
      if (!window.SkiSisesBisMini) {
        var bis = card.querySelector("[data-bis]");
        if (bis) { bis.style.display = "flex"; var inp = bis.querySelector("input[name=email]"); if (inp) inp.focus(); }
        return;
      }
      window.SkiSisesBisMini.open({
        productId: productId,
        productHandle: card.getAttribute("data-handle") || "",
        productTitle: titleEl ? (titleEl.textContent || "").trim() : "",
        productVendor: card.getAttribute("data-vendor") || "",
        productImage: imgEl ? (imgEl.getAttribute("src") || "") : "",
        variantId: opt ? String(opt.value) : "",
        variantTitle: opt ? (opt.textContent || "").trim() : "",
        sku: opt ? (opt.getAttribute("data-sku") || "") : "",
        price: opt ? (opt.getAttribute("data-price") || "") : ""
      });
    },

    sizeChart: function (btnOrId, itemId) {
      var body = document.getElementById("op-sizechart-body");
      var modal = document.getElementById("op-sizechart");
      if (!body || !modal) return;
      body.innerHTML = "Loading…";
      modal.hidden = false;
      var card = (btnOrId && btnOrId.closest) ? btnOrId.closest(".op-card") : null;
      var titleEl = card && card.querySelector(".op-card-title");
      var params = [];
      var tags = card && card.getAttribute("data-tags");
      var title = titleEl ? (titleEl.textContent || "").trim() : "";
      var type = card && card.getAttribute("data-type");
      var vendor = card && card.getAttribute("data-vendor");
      if (tags) params.push("tags=" + encodeURIComponent(tags));
      if (title) params.push("title=" + encodeURIComponent(title));
      if (type) params.push("type=" + encodeURIComponent(type));
      if (vendor) params.push("vendor=" + encodeURIComponent(vendor));
      if (!params.length) { body.innerHTML = "Size chart unavailable."; return; }
      fetch(SIZECHART_BASE + "/size-charts/api/chart?" + params.join("&"))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.html_table) { body.innerHTML = _lbl("no-size-chart") || "No size guide for this product."; return; }
          body.innerHTML = "<h3>" + (d.name || _lbl("size") || "Size guide") + "</h3>" + d.html_table;
        })
        .catch(function () { body.innerHTML = "Size chart unavailable right now."; });
    },

    closeSizeChart: function () {
      var modal = document.getElementById("op-sizechart");
      if (modal) modal.hidden = true;
    },

    galleryGoto: galleryGoto,
    galleryNav: galleryNav,
    toggleFullscreen: toggleFullscreen,
    openImm: openImm,

    backInStock: function (event, productId, itemId) {
      event.preventDefault();
      var form = event.target;
      var card = form.closest(".op-card");
      var sel = card && card.querySelector(".op-variant");
      var opt = sel && selectedOption(sel);
      var email = form.querySelector("input[name=email]").value;
      if (!API) { alert("Notifications unavailable right now."); return false; }
      fetch(API + "/back-in-stock", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          product_id: productId,
          variant_id: opt ? String(opt.value) : "",
          item_id: itemId || ITEM,
          email: email,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          alert(d.ok ? "We'll email you when it's back." : (d.error || "Could not subscribe."));
          if (d.ok) form.reset();
        })
        .catch(function () { alert("Could not subscribe right now."); });
      return false;
    },
  };

  function _doAddLook(btn, items, origLbl, lookAddedLbl) {
    track("add_look_to_cart", {});
    ga("add_look_to_cart", { products: items.length });
    if (window.fbq) fbq('track', 'AddToCart', { content_ids: [ITEM], content_type: 'product_group', currency: 'EUR' });
    var cartItems = items.map(function (i) { return { id: i.id, quantity: i.quantity }; });
    btn.disabled = true;
    cartAdd(cartItems)
      .then(function (result) {
        btn.innerHTML = lookAddedLbl;
        refreshCartCount();
        refreshAndOpenDrawer(result);
        setTimeout(function () { btn.innerHTML = origLbl; btn.disabled = false; }, 2500);
      })
      .catch(function (err) {
        btn.innerHTML = origLbl;
        btn.disabled = false;
        alert((err && err.description) || "Could not add the look");
      });
  }

  /* ── Drag-scroll for native related-outfits track ────────────────────────── */
  function _initDrag(track) {
    var isDown = false, startX = 0, scrollLeft = 0;
    track.addEventListener("mousedown", function (e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; track.style.cursor = "grabbing";
    });
    track.addEventListener("mouseleave", function () { isDown = false; track.style.cursor = ""; });
    track.addEventListener("mouseup", function () { isDown = false; track.style.cursor = ""; });
    track.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX);
    });
  }

  /* ── Gallery swipe ───────────────────────────────────────────────────────── */
  function _initSwipe() {
    var g = document.querySelector("[data-gallery]");
    if (!g) return;
    var sx = 0, sy = 0;
    g.addEventListener("touchstart", function (e) {
      sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY;
    }, { passive: true });
    g.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galleryNav(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ── Close modals on overlay click ──────────────────────────────────────── */
  document.querySelectorAll(".op-modal").forEach(function (m) {
    m.addEventListener("click", function (e) { if (e.target === m) m.hidden = true; });
  });

  /* ── Reflect shared-wishlist state on the outfit hearts ──────────────────── */
  document.addEventListener("integrated:wishlist:change", function (e) {
    var detail = e.detail || {};
    if (!detail.handle || !detail.selected) return;
    document.querySelectorAll('.op-card[data-handle="' + detail.handle + '"]').forEach(function (card) {
      var heart = card.querySelector(".op-btn-wish, [data-fav-product]");
      if (heart) _markFav(heart);
    });
  });

  /* ── Init ────────────────────────────────────────────────────────────────── */
  document.querySelectorAll(".op-card .op-variant").forEach(function (sel) {
    // Pre-select first available variant so the add button is ready immediately
    var cur = selectedOption(sel);
    if (!cur || cur.getAttribute("data-available") !== "true") {
      var idx = firstAvailableIndex(sel);
      if (idx >= 0) sel.selectedIndex = idx;
    }
    syncCardState(sel);
  });

  _updateLookTotal();
  _initSwipe();
  var relTrack = document.querySelector("[data-related-track]");
  if (relTrack) _initDrag(relTrack);

  track("image_view", {});
  ga("outfit_page_view", {});
  if (window.fbq) fbq('track', 'ViewContent', { content_ids: [ITEM], content_type: 'product_group' });
  window.addEventListener("beforeunload", function () {
    track("image_view", { duration_ms: Date.now() - _viewStart });
  });

  window.OutfitPage = OutfitPage;
  window._updateLookTotal = _updateLookTotal;
})();
